import React from 'react';
import { connect } from 'react-redux';
import {
  Typography,
  Button,
  Icon,
  Size,
  Color
} from '@americanexpress/aqx-components';
import { getCombinedG163Data } from './redux';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import styles from './__styles__/index.scss?modules';

const createJumpLinkHandler = linkObj => {
  return () => {
    const targetEle = document.querySelector(linkObj.target);
    if (targetEle && typeof targetEle.getBoundingClientRect === 'function') {
      const currTop = targetEle.getBoundingClientRect().top;
      const offsetForSubNav = 70;
      const topPos = currTop + window.scrollY - offsetForSubNav;
      window.scrollTo({ top: topPos, behavior: 'smooth' });
      setTimeout(() => {
        sendDTMClickEvent(linkObj.dtm);
      }, 10);
    }
  };
};

const ItemUnit = ({ item }) => {
  return (
    <li className={styles.itemUnit}>
      <Icon
        className={styles.itemIcon}
        directory="dls"
        imageName={item.imgName}
        $size={Size.MD}
        theme={{
          color: Color.White,
          margin: 0,
          padding: 0
        }}
      />
      <div className={styles.unitTextBox}>
        <Typography className={styles.unitText}>{`${item.text}`}</Typography>
        <Button
          className={styles.jumpLink}
          Component="a"
          aria-label={item.link?.title}
          title={item.link?.title}
          onClick={createJumpLinkHandler(item.link)}
        >
          {item.link?.text}
        </Button>
      </div>
    </li>
  );
};

const CardHighlights = ({ staticG163Data }) => {
  const { cardHighlights } = staticG163Data;

  return (
    <div className={styles.cardHighlights}>
      <Typography Component="h2" className={styles.cardHighlightHeader}>
        {cardHighlights?.header}
      </Typography>
      <ul className={styles.listBox}>
        {(cardHighlights?.contents || []).map((item, i) => {
          return <ItemUnit key={`k${i}`} item={item} />;
        })}
      </ul>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...getCombinedG163Data(state)
  };
};

export default connect(mapStateToProps)(React.memo(CardHighlights));
